(function () {
    var PAGE_SIZE = 250;
    var CACHE_TTL_MS = 30 * 60 * 1000;
    var CACHE_PREFIX = 'kg-sizing-catalog-v4:';
    var catalogState = { byHandle: Object.create(null) };

    function parseDimension(value) {
      var cleaned = String(value || '')
        .trim()
        .replace(/,/g, '')
        .replace(/["']/g, '')
        .replace(/\s*(?:in(?:ches)?|")\s*$/i, '');

      if (cleaned === '') return { ok: false, reason: 'required' };
      if (!/^\d+(\.\d+)?$/.test(cleaned)) return { ok: false, reason: 'invalid' };

      var number = Number(cleaned);
      if (!Number.isFinite(number) || number <= 0) {
        return { ok: false, reason: number <= 0 ? 'min' : 'invalid' };
      }

      return { ok: true, value: number };
    }

    function dimensionMessage(reason, label) {
      if (reason === 'required') return 'Enter a ' + label + '.';
      if (reason === 'min') return label + ' must be greater than 0.';
      return 'Enter a valid ' + label + ' in inches.';
    }

    function selectedMaterialValue(panel) {
      var select = panel.querySelector('[data-kg-box-material]');
      return select ? String(select.value || '').trim() : '';
    }

    function buildQuery(length, width, height, material) {
      var dimensions = height
        ? length + ' x ' + width + ' x ' + height
        : length + ' x ' + width;
      return [dimensions, material].filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
    }

    function storeRoot() {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      return root || '/';
    }

    function buildSearchUrl(query, collectionUrl) {
      var params = new URLSearchParams();
      params.set('q', query);
      params.set('type', 'product');

      if (collectionUrl) {
        var separator = collectionUrl.indexOf('?') >= 0 ? '&' : '?';
        return collectionUrl + separator + params.toString();
      }

      return storeRoot() + 'search?' + params.toString();
    }

    function setSubmitting(button, panel, isSubmitting) {
      var submitLabel = panel.dataset.submitLabel || 'Find My Box';
      var loadingLabel = panel.dataset.loadingLabel || 'Finding...';
      button.disabled = isSubmitting;
      button.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
      button.textContent = isSubmitting ? loadingLabel : submitLabel;
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function normalizeText(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[\u00d7\u2715\u2716]/g, ' x ')
        .replace(/[^a-z0-9.]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function numbersClose(a, b) {
      return Math.abs(Number(a) - Number(b)) < 0.001;
    }

    function extractAllDimensions(text) {
      var normalized = normalizeText(text);
      var matches = [];
      var pattern =
        /(^|\s)(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)(?:\s*x\s*(\d+(?:\.\d+)?))?(?=\s|$)/g;

      var match;
      while ((match = pattern.exec(normalized)) !== null) {
        matches.push({
          length: Number(match[2]),
          width: Number(match[3]),
          height: match[4] != null ? Number(match[4]) : null,
        });
      }

      return matches;
    }

    function hasMaterial(text, material) {
      var materialWords = normalizeText(material).split(' ').filter(Boolean);
      if (!materialWords.length) return true;
      return materialWords.every(function (word) {
        return text.indexOf(word) !== -1;
      });
    }

    function lengthWidthMatch(dims, length, width) {
      return (
        (numbersClose(dims.length, length) && numbersClose(dims.width, width)) ||
        (numbersClose(dims.length, width) && numbersClose(dims.width, length))
      );
    }

    function productUrl(handle, variantId) {
      var base = storeRoot() + 'products/' + handle;
      return variantId ? base + '?variant=' + variantId : base;
    }

    function displayTitle(productTitle, variantTitle) {
      var variant = String(variantTitle || '').trim();
      if (!variant || /^default\s*title$/i.test(variant)) return productTitle;
      return productTitle + ' - ' + variant;
    }

    function normalizeTags(tags) {
      if (Array.isArray(tags)) return tags.map(String);
      if (typeof tags === 'string' && tags.trim()) {
        return tags.split(',').map(function (tag) {
          return tag.trim();
        });
      }
      return [];
    }

    function cacheKey(handle) {
      return CACHE_PREFIX + handle;
    }

    function readCachedCatalog(handle) {
      try {
        var raw = sessionStorage.getItem(cacheKey(handle));
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (!parsed || !Array.isArray(parsed.entries) || !parsed.savedAt) return null;
        if (!parsed.entries.length) return null;
        if (Date.now() - parsed.savedAt > CACHE_TTL_MS) return null;
        return parsed.entries;
      } catch (error) {
        return null;
      }
    }

    function writeCachedCatalog(handle, entries) {
      if (!entries || !entries.length) return;
      try {
        sessionStorage.setItem(
          cacheKey(handle),
          JSON.stringify({ savedAt: Date.now(), entries: entries })
        );
      } catch (error) {}
    }

    function buildCatalogEntries(products) {
      var entries = [];

      (products || []).forEach(function (product) {
        var handle = product && product.handle;
        if (!handle) return;

        var productTitle = String(product.title || '');
        var tags = normalizeTags(product.tags);
        var productText = normalizeText(
          [productTitle, product.product_type, product.vendor].concat(tags).join(' ')
        );
        var variants = Array.isArray(product.variants) ? product.variants : [];

        if (!variants.length) {
          extractAllDimensions(productText).forEach(function (dims) {
            entries.push({
              title: productTitle,
              url: productUrl(handle),
              text: productText,
              dims: dims,
              available: true,
            });
          });
          return;
        }

        variants.forEach(function (variant) {
          var variantTitle = String(variant.title || '');
          var optionText = [variant.option1, variant.option2, variant.option3]
            .filter(Boolean)
            .join(' ');
          var combinedTitle = displayTitle(productTitle, variantTitle);
          var text = normalizeText(
            [productTitle, variantTitle, optionText, product.product_type, product.vendor].join(' ')
          );
          var dimsList = extractAllDimensions(text);

          if (!dimsList.length) {
            extractAllDimensions(productText).forEach(function (dims) {
              entries.push({
                title: combinedTitle,
                url: productUrl(handle, variant.id),
                text: text || productText,
                dims: dims,
                available: variant.available !== false,
              });
            });
            return;
          }

          dimsList.forEach(function (dims) {
            entries.push({
              title: combinedTitle,
              url: productUrl(handle, variant.id),
              text: text,
              dims: dims,
              available: variant.available !== false,
            });
          });
        });
      });

      return entries;
    }

    function productsEndpoint(page) {
      return storeRoot() + 'products.json?limit=' + PAGE_SIZE + '&page=' + page;
    }

    function collectionEndpoint(handle, page) {
      return (
        storeRoot() +
        'collections/' +
        encodeURIComponent(handle || 'all') +
        '/products.json?limit=' +
        PAGE_SIZE +
        '&page=' +
        page
      );
    }

    function fetchJson(url) {
      return fetch(url, { headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error('Request failed: ' + response.status);
        return response.json();
      });
    }

    function fetchPageProducts(handle, page) {
      var useProductsJson = !handle || handle === 'all';
      var primaryUrl = useProductsJson
        ? productsEndpoint(page)
        : collectionEndpoint(handle, page);
      var fallbackUrl = useProductsJson
        ? collectionEndpoint('all', page)
        : productsEndpoint(page);

      return fetchJson(primaryUrl)
        .then(function (data) {
          return Array.isArray(data.products) ? data.products : [];
        })
        .catch(function () {
          return fetchJson(fallbackUrl).then(function (data) {
            return Array.isArray(data.products) ? data.products : [];
          });
        });
    }

    function fetchFullCatalog(handle) {
      return fetchPageProducts(handle, 1).then(function (firstPage) {
        var products = firstPage.slice();

        if (firstPage.length < PAGE_SIZE) {
          return buildCatalogEntries(products);
        }

        var page = 2;
        var maxPages = 40;

        function loadBatch() {
          if (page > maxPages) return Promise.resolve(buildCatalogEntries(products));

          var batchSize = Math.min(4, maxPages - page + 1);
          var requests = [];

          for (var i = 0; i < batchSize; i += 1) {
            requests.push(fetchPageProducts(handle, page + i));
          }

          return Promise.all(requests).then(function (pages) {
            var reachedEnd = false;

            pages.forEach(function (pageProducts) {
              products.push.apply(products, pageProducts);
              if (pageProducts.length < PAGE_SIZE) reachedEnd = true;
            });

            if (reachedEnd) return buildCatalogEntries(products);
            page += batchSize;
            return loadBatch();
          });
        }

        return loadBatch();
      });
    }

    function getCatalog(handle) {
      var key = handle || 'all';
      var existing = catalogState.byHandle[key];

      if (existing && existing.entries && existing.entries.length) {
        return Promise.resolve(existing.entries);
      }

      if (existing && existing.promise) return existing.promise;

      var cached = readCachedCatalog(key);
      if (cached && cached.length) {
        catalogState.byHandle[key] = { entries: cached, promise: null };
        return Promise.resolve(cached);
      }

      var promise = fetchFullCatalog(key)
        .then(function (entries) {
          catalogState.byHandle[key] = { entries: entries, promise: null };
          writeCachedCatalog(key, entries);
          return entries;
        })
        .catch(function (error) {
          delete catalogState.byHandle[key];
          throw error;
        });

      catalogState.byHandle[key] = { entries: null, promise: promise };
      return promise;
    }

    function scoreEntry(entry, length, width, height, material) {
      var dims = entry.dims;
      if (!lengthWidthMatch(dims, length, width)) return null;

      var materialMatched = hasMaterial(entry.text, material);
      var hasRequestedHeight = height !== '';
      var heightMatched =
        hasRequestedHeight && dims.height != null && numbersClose(dims.height, height);
      var heightMissingInCatalog = hasRequestedHeight && dims.height == null;

      var score = 0;

      if (hasRequestedHeight && heightMatched && materialMatched) score = 1000;
      else if (hasRequestedHeight && heightMatched) score = 850;
      else if (!hasRequestedHeight && materialMatched) score = 800;
      else if (!hasRequestedHeight) score = 650;
      else if (heightMissingInCatalog && materialMatched) score = 600;
      else if (materialMatched) score = 500;
      else score = 300;

      if (entry.available) score += 5;

      return {
        title: entry.title,
        url: entry.url,
        text: entry.text,
        dims: entry.dims,
        available: entry.available,
        score: score,
        exact:
          (hasRequestedHeight && heightMatched && materialMatched) ||
          (!hasRequestedHeight && materialMatched && lengthWidthMatch(dims, length, width)),
      };
    }

    function findMatches(entries, length, width, height, material) {
      var scored = [];

      for (var i = 0; i < entries.length; i += 1) {
        var result = scoreEntry(entries[i], length, width, height, material);
        if (result) scored.push(result);
      }

      scored.sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return String(a.title).localeCompare(String(b.title));
      });

      var unique = [];
      var seen = {};

      scored.forEach(function (item) {
        if (seen[item.url]) return;
        seen[item.url] = true;
        unique.push(item);
      });

      return unique;
    }

    function suggestFallback(query) {
      var params = new URLSearchParams({
        q: query,
        'resources[type]': 'product',
        'resources[limit]': '10',
      });

      return fetchJson(storeRoot() + 'search/suggest.json?' + params.toString()).then(
        function (data) {
          var products =
            (data &&
              data.resources &&
              data.resources.results &&
              data.resources.results.products) ||
            [];

          return products.map(function (product) {
            var title = String(product.title || '');
            var dimsList = extractAllDimensions(title);
            var dims = dimsList[0] || { length: 0, width: 0, height: null };

            return {
              title: title,
              url: product.url || '#',
              text: normalizeText(title),
              dims: dims,
              available: true,
            };
          });
        }
      );
    }

    function prefetchCatalog(panel) {
      getCatalog(panel.dataset.catalogHandle || 'all').catch(function () {});
    }

    function bindPanel(panel) {
      if (!panel || panel.dataset.kgSizingBound === 'true') return;
      panel.dataset.kgSizingBound = 'true';

      var lengthInput = panel.querySelector('[data-kg-length]');
      var widthInput = panel.querySelector('[data-kg-width]');
      var heightInput = panel.querySelector('[data-kg-height]');
      var submitButton = panel.querySelector('[data-kg-submit]');
      var feedback = panel.querySelector('[data-kg-search-feedback]');

      if (!lengthInput || !widthInput || !heightInput || !submitButton) return;

      prefetchCatalog(panel);

      panel.addEventListener('input', function (event) {
        event.stopPropagation();
      });
      panel.addEventListener('change', function (event) {
        event.stopPropagation();
      });

      [lengthInput, widthInput, heightInput].forEach(function (input) {
        input.addEventListener('input', function () {
          input.setCustomValidity('');
          if (feedback) {
            feedback.hidden = true;
            feedback.textContent = '';
          }
        });

        input.addEventListener('keydown', function (event) {
          event.stopPropagation();
          if (event.key === 'Enter') {
            event.preventDefault();
            submitButton.click();
          }
        });
      });

      var materialSelect = panel.querySelector('[data-kg-box-material]');
      if (materialSelect) {
        materialSelect.addEventListener('change', function () {
          if (feedback) {
            feedback.hidden = true;
            feedback.textContent = '';
          }
        });
      }

      function renderChoiceLinks(matches) {
        return matches
          .slice(0, 6)
          .map(function (item) {
            return (
              '<li><a href="' +
              escapeHtml(item.url || '#') +
              '">' +
              escapeHtml(item.title || '') +
              '</a></li>'
            );
          })
          .join('');
      }

      function showErrorFeedback(message, searchUrl) {
        if (!feedback) return;
        feedback.hidden = false;
        feedback.className = 'kg-search-feedback kg-search-feedback--error';

        var browseLink = searchUrl
          ? '<div class="kg-search-feedback__browse"><a href="' +
            escapeHtml(searchUrl) +
            '">Browse all related boxes</a></div>'
          : '';

        feedback.innerHTML =
          '<strong>No exact variant match was found.</strong>' +
          '<div class="kg-search-feedback__message">' +
          escapeHtml(message) +
          '</div>' +
          browseLink;
      }

      function showChoicesFeedback(matches, query, searchUrl) {
        if (!feedback) return;
        feedback.hidden = false;
        feedback.className = 'kg-search-feedback kg-search-feedback--success';

        var count = matches.length;
        var heading =
          count === 1 ? 'We found a matching box.' : 'We found ' + count + ' matching options.';
        var label = count === 1 ? 'Choose this box:' : 'Choose one of these boxes:';
        var browseLink = searchUrl
          ? '<div class="kg-search-feedback__browse"><a href="' +
            escapeHtml(searchUrl) +
            '">Browse all related boxes</a></div>'
          : '';

        feedback.innerHTML =
          '<strong>' +
          escapeHtml(heading) +
          '</strong>' +
          '<div class="kg-search-feedback__message">Results for "' +
          escapeHtml(query) +
          '".</div>' +
          '<div class="kg-search-feedback__label">' +
          escapeHtml(label) +
          '</div>' +
          '<ul>' +
          renderChoiceLinks(matches) +
          '</ul>' +
          browseLink;
      }

      function handleResults(matches, query, searchUrl) {
        var exactMatches = matches.filter(function (item) {
          return item.exact || item.score >= 850;
        });
        var choiceMatches = exactMatches.length
          ? exactMatches
          : matches.filter(function (item) {
              return item.score >= 500;
            });

        if (exactMatches.length === 1 && exactMatches[0].url) {
          panel.dataset.kgRedirecting = 'true';
          if (feedback) {
            feedback.hidden = true;
            feedback.innerHTML = '';
          }
          window.location.assign(exactMatches[0].url);
          return;
        }

        if (choiceMatches.length > 0) {
          showChoicesFeedback(choiceMatches, query, searchUrl);
          return;
        }

        showErrorFeedback(
          'No similar products were found for "' +
            query +
            '". Try different dimensions or material.',
          searchUrl
        );
      }

      submitButton.addEventListener('click', function () {
        if (panel.dataset.kgRedirecting === 'true') return;

        lengthInput.setCustomValidity('');
        widthInput.setCustomValidity('');
        heightInput.setCustomValidity('');

        var lengthResult = parseDimension(lengthInput.value);
        var widthResult = parseDimension(widthInput.value);
        var heightValue = heightInput.value.trim();
        var heightResult = heightValue
          ? parseDimension(heightValue)
          : { ok: true, value: '' };

        if (!lengthResult.ok) {
          lengthInput.setCustomValidity(dimensionMessage(lengthResult.reason, 'length'));
          lengthInput.reportValidity();
          lengthInput.focus();
          return;
        }

        if (!widthResult.ok) {
          widthInput.setCustomValidity(dimensionMessage(widthResult.reason, 'width'));
          widthInput.reportValidity();
          widthInput.focus();
          return;
        }

        if (!heightResult.ok) {
          heightInput.setCustomValidity(dimensionMessage(heightResult.reason, 'height'));
          heightInput.reportValidity();
          heightInput.focus();
          return;
        }

        var material = selectedMaterialValue(panel);
        var query = buildQuery(
          lengthResult.value,
          widthResult.value,
          heightResult.value,
          material
        );
        var fallbackQuery = buildQuery(
          lengthResult.value,
          widthResult.value,
          '',
          material
        );
        var collectionUrl = panel.dataset.collectionUrl || '';
        var searchUrl = buildSearchUrl(query, collectionUrl);
        var catalogHandle = panel.dataset.catalogHandle || 'all';

        if (feedback) {
          feedback.hidden = true;
          feedback.textContent = '';
        }

        setSubmitting(submitButton, panel, true);
        panel.dataset.kgRedirecting = 'false';

        getCatalog(catalogHandle)
          .then(function (entries) {
            if (entries && entries.length) {
              return findMatches(
                entries,
                lengthResult.value,
                widthResult.value,
                heightResult.value,
                material
              );
            }

            return suggestFallback(fallbackQuery).then(function (suggestEntries) {
              return findMatches(
                suggestEntries,
                lengthResult.value,
                widthResult.value,
                heightResult.value,
                material
              );
            });
          })
          .catch(function () {
            return suggestFallback(fallbackQuery).then(function (suggestEntries) {
              return findMatches(
                suggestEntries,
                lengthResult.value,
                widthResult.value,
                heightResult.value,
                material
              );
            });
          })
          .then(function (matches) {
            handleResults(matches || [], query, searchUrl);
          })
          .catch(function () {
            showErrorFeedback(
              'We could not load the product catalog right now. Please try again.',
              searchUrl
            );
          })
          .finally(function () {
            if (panel.dataset.kgRedirecting === 'true') return;
            setSubmitting(submitButton, panel, false);
          });
      });
    }

    function initSizingTools() {
      document.querySelectorAll('[data-kg-sizing-tool]').forEach(bindPanel);
    }

    window.KgSizingTool = {
      init: initSizingTools,
      rebind: function () {
        document.querySelectorAll('[data-kg-sizing-tool]').forEach(function (panel) {
          panel.dataset.kgSizingBound = 'false';
          bindPanel(panel);
        });
      },
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSizingTools, { once: true });
    } else {
      initSizingTools();
    }

    document.addEventListener('shopify:section:load', function () {
      window.KgSizingTool.rebind();
    });
  })();
